export default __webpack_public_path__ + "static/media/Squash-Court.e97b5170.webp";